import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3;
import { jsx, jsxs } from 'react/jsx-runtime';
import { theme, FileInput, Text } from '@dls/web';
import CustomController from './CustomController.js';
import styled, { css } from 'styled-components';
import { buildErrorMessage } from './helpers/utils.js';
import { getFileExtension } from '@geit/helpers';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
const FileInputController = _a => {
  var _b = _a,
    {
      name,
      control,
      defaultValue,
      isSingleUploadMode,
      rules,
      shouldUnregister,
      maxSize,
      maxSizeError = "File(s) too large: ",
      maxFiles,
      maxFilesError = "Maximum number of file uploads has been exceeded",
      filesExtensionError = "Please upload a valid supported file type"
    } = _b,
    fileInputProps = __objRest(_b, ["name", "control", "defaultValue", "isSingleUploadMode", "rules", "shouldUnregister", "maxSize", "maxSizeError", "maxFiles", "maxFilesError", "filesExtensionError"]);
  const {
    label
  } = fileInputProps;
  return /* @__PURE__ */jsx(CustomController, {
    name,
    control,
    defaultValue,
    rules: __spreadValues({
      validate: fs => {
        let errorFilesSize = [];
        let errorFilesExtension = [];
        if (maxFiles && (fs == null ? void 0 : fs.length) > maxFiles) {
          return maxFilesError;
        }
        fs == null ? void 0 : fs.forEach(file => {
          var _a2, _b2;
          if (maxSize && file.size > maxSize) {
            errorFilesSize.push(file.name);
          } else if (((_b2 = (_a2 = fileInputProps.inputProps) == null ? void 0 : _a2.accept) == null ? void 0 : _b2.indexOf("." + getFileExtension(file.name))) === -1) {
            errorFilesExtension.push(file.name);
          }
        });
        if (errorFilesExtension.length) {
          return filesExtensionError;
        }
        if (errorFilesSize.length) {
          return typeof maxSizeError === "string" ? maxSizeError + errorFilesSize.join(", ") : maxSizeError(errorFilesSize);
        }
        return void 0;
      }
    }, rules),
    shouldUnregister,
    render: _ref => {
      let {
        field,
        fieldState: {
          error
        }
      } = _ref;
      const files = field.value || [];
      const handleDropFiles = fs => {
        fs == null ? void 0 : fs.forEach(file => {
          file.id = Math.random().toString();
        });
        if (isSingleUploadMode) {
          field.onChange(fs);
        } else {
          let addedFiles = [...files, ...fs];
          field.onChange(addedFiles);
        }
      };
      const handleDeleteFile = file => {
        if (isSingleUploadMode) {
          field.onChange([]);
        } else {
          if (files) {
            const remainingFiles = files.filter(f => f !== file);
            field.onChange(remainingFiles);
          }
        }
      };
      const errorMessage = buildErrorMessage({
        error,
        label,
        rules
      });
      return /* @__PURE__ */jsxs(FileInput, {
        label,
        children: [!isSingleUploadMode && /* @__PURE__ */jsx(FileInput.ListItemWrapper, {
          children: files == null ? void 0 : files.map(file => /* @__PURE__ */jsx(FileInput.FileListItem, {
            status: file.error ? "failure" : "success",
            action: /* @__PURE__ */jsx(FileInput.IconTrashButton, {
              onClick: () => handleDeleteFile(file)
            }),
            animate: false,
            listType: "text",
            children: file.name
          }, file.id))
        }), /* @__PURE__ */jsx(SCFocusHelpInput, {
          ref: field.ref
        }), /* @__PURE__ */jsx(SCDropZone, {
          isError: !!errorMessage,
          children: /* @__PURE__ */jsx(FileInput.DropZone, __spreadValues({
            onDrop: handleDropFiles,
            isSingleUploadMode,
            singleModeOnDelete: handleDeleteFile,
            singleUploadStatus: isSingleUploadMode ? "success" : void 0
          }, fileInputProps))
        }), errorMessage && /* @__PURE__ */jsx(Text, {
          type: "smallBody",
          color: theme.main.colours.errorRed,
          children: errorMessage
        })]
      });
    }
  });
};
const SCDropZone = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), props => props.isError && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      div[data-testid='dropZone'] {\n        border-color: ", ";\n        border-style: solid;\n      }\n    "])), theme.main.colours.errorRed));
const SCFocusHelpInput = styled.input(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 0;\n  height: 0;\n  padding: 0;\n  border: 0;\n  position: absolute;\n  z-index: -1;\n"])));
export { FileInputController as default };